import { find } from 'ramda';
import { TeamInSeasonRegistryResource } from '~~apis/resource';
import RMultilingual from '../../Tournament/Registry/Multilingual';
import moment from 'moment';

export const parseTeamData = (teamInRegistry, registry) => {
  const columns = [];
  registry.team_columns.forEach((teamColumn) => {
    // 已經有同名欄位就不放
    if (find((c) => c.name === teamColumn.name, columns)) {
      return;
    }

    const column = {
      ...teamColumn,
      value: '',
      url: '',
    };

    const filledColumn = find((c) => c.name === teamColumn.name && c.type === teamColumn.type, teamInRegistry.columns);
    if (filledColumn) {
      column.value = filledColumn.value;
      column.url = filledColumn.url;
      if (column.type === 'DATE') {
        column.value =
          !filledColumn.value || !moment(filledColumn.value).isValid()
            ? ''
            : moment(filledColumn.value).format('YYYY-MM-DD');
      }
    }

    columns.push(column);
  });

  return {
    name: teamInRegistry.name,
    city: !teamInRegistry.connected_team ? teamInRegistry.city : teamInRegistry.connected_team.city,
    icon_path: teamInRegistry.icon_path,
    icon_url: !teamInRegistry.connected_team ? teamInRegistry.icon_url : teamInRegistry.connected_team.icon_url,
    contact_person: teamInRegistry.contact_person,
    contact_phone: teamInRegistry.contact_phone,
    connected_team: !teamInRegistry.connected_team ? '' : teamInRegistry.connected_team.uniqid,
    columns,
    remove_image_paths: [],
    remove_file_paths: [],
  };
};

export const validTeamData = (teamData) => {
  const name = teamData.name.trim();
  const city = teamData.city.trim();
  const contact_person = teamData.contact_person.trim();
  const contact_phone = teamData.contact_phone.trim();

  const errorResponse = {
    error: true,
    message: '',
    data: null,
  };
  if (!name) {
    errorResponse.message = `${RMultilingual(`DEFAULT_COLUMN.TEAM.NAME.NAME`)} ${RMultilingual(
      `FORM.ERROR.IS_REQUIRED`,
    )}`;
    return errorResponse;
  }
  if (!city && !teamData.connected_team) {
    errorResponse.message = `${RMultilingual(`DEFAULT_COLUMN.TEAM.CITY.NAME`)} ${RMultilingual(
      `FORM.ERROR.IS_REQUIRED`,
    )}`;
    return errorResponse;
  }
  if (!contact_person) {
    errorResponse.message = `${RMultilingual(`DEFAULT_COLUMN.TEAM.CONTACT_PERSON.NAME`)} ${RMultilingual(
      `FORM.ERROR.IS_REQUIRED`,
    )}`;
    return errorResponse;
  }
  if (!contact_phone) {
    errorResponse.message = `${RMultilingual(`DEFAULT_COLUMN.TEAM.CONTACT_PHONE.NAME`)} ${RMultilingual(
      `FORM.ERROR.IS_REQUIRED`,
    )}`;
    return errorResponse;
  }

  return {
    error: false,
    message: '',
    data: {
      ...teamData,
      name,
      city,
      contact_person,
      contact_phone,
      columns: teamData.columns.map((column) => ({
        name: column.name,
        type: column.type,
        value: column.value,
        url: column.url,
      })),
      remove_image_paths: [...teamData.remove_image_paths],
      remove_file_paths: [...teamData.remove_file_paths],
    },
  };
};

export const updateTeamData = (registryUniqid, teamInRegistryUniqid, data) => {
  return new Promise((resolve, reject) => {
    TeamInSeasonRegistryResource.updateTeamData({ registryUniqid, teamInRegistryUniqid, data })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const parseStaffsData = (teamInRegistry, registry) => {
  const staffs = [];
  registry.staff_titles.forEach((teamStaff) => {
    // 已經有同名人員就不放
    if (find((s) => s.title === teamStaff.title, staffs)) {
      return;
    }

    const staff = {
      ...teamStaff,
    };

    let filledColumns = [];
    const filledStaff = find((s) => s.title === teamStaff.title, teamInRegistry.staffs);
    if (filledStaff) {
      filledColumns = filledStaff.columns;
    }

    const columns = [];
    teamStaff.columns.forEach((staffColumn) => {
      // 已經有同名欄位就不放
      if (find((c) => c.name === staffColumn.name, columns)) {
        return;
      }

      const column = {
        ...staffColumn,
        value: '',
        url: '',
      };

      const filledColumn = find((c) => c.name === staffColumn.name && c.type === staffColumn.type, filledColumns);
      if (filledColumn) {
        column.value = filledColumn.value;
        column.url = filledColumn.url;
        if (column.type === 'DATE') {
          column.value =
            !filledColumn.value || !moment(filledColumn.value).isValid()
              ? ''
              : moment(filledColumn.value).format('YYYY-MM-DD');
        }
      }

      columns.push(column);
    });
    staff.columns = columns;
    staffs.push(staff);
  });

  return {
    staffs,
    remove_image_paths: [],
    remove_file_paths: [],
  };
};

export const validStaffsData = (staffsData) => {
  return {
    error: false,
    message: '',
    data: {
      staffs: staffsData.staffs.map((staff) => ({
        title: staff.title,
        columns: staff.columns.map((column) => ({
          name: column.name,
          type: column.type,
          value: column.value,
          url: column.url,
        })),
      })),
      remove_image_paths: [...staffsData.remove_image_paths],
      remove_file_paths: [...staffsData.remove_file_paths],
    },
  };
};

export const updateStaffsData = (registryUniqid, teamInRegistryUniqid, data) => {
  return new Promise((resolve, reject) => {
    TeamInSeasonRegistryResource.updateStaffsData({ registryUniqid, teamInRegistryUniqid, data })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const parsePlayersData = (teamInRegistry, registry) => {
  const players = [];
  teamInRegistry.players.forEach((player) => {
    const columns = [];
    registry.player_columns.forEach((playerColumn) => {
      // 已經有同名欄位就不放
      if (find((c) => c.name === playerColumn.name, columns)) {
        return;
      }

      const column = {
        ...playerColumn,
        value: '',
        url: '',
      };

      const filledColumn = find((c) => c.name === playerColumn.name && c.type === playerColumn.type, player.columns);
      if (filledColumn) {
        column.value = filledColumn.value;
        column.url = filledColumn.url;
        if (column.type === 'DATE') {
          column.value =
            !filledColumn.value || !moment(filledColumn.value).isValid()
              ? ''
              : moment(filledColumn.value).format('YYYY-MM-DD');
        }
      }

      columns.push(column);
    });

    players.push({
      ...player,
      birthday:
        !player.birthday || !moment(player.birthday).isValid() ? '' : moment(player.birthday).format('YYYY-MM-DD'),
      columns,
    });
  });

  return {
    players,
    remove_image_paths: [],
    remove_file_paths: [],
  };
};

export const validPlayersData = (playersData) => {
  return {
    error: false,
    message: '',
    data: {
      players: playersData.players.map((player) => ({
        ...player,
        columns: player.columns.map((column) => ({
          name: column.name,
          type: column.type,
          value: column.value,
          url: column.url,
        })),
      })),
      remove_image_paths: [...playersData.remove_image_paths],
      remove_file_paths: [...playersData.remove_file_paths],
    },
  };
};

export const updatePlayersData = (registryUniqid, teamInRegistryUniqid, data) => {
  return new Promise((resolve, reject) => {
    TeamInSeasonRegistryResource.updatePlayersData({ registryUniqid, teamInRegistryUniqid, data })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const parsePDFData = (teamInRegistry, registry) => {
  const columns = [];
  registry.team_columns.forEach((teamColumn) => {
    if (teamColumn.type !== 'PDF') {
      return;
    }

    // 已經有同名欄位就不放
    if (find((c) => c.name === teamColumn.name, columns)) {
      return;
    }

    const column = {
      ...teamColumn,
      value: '',
      url: '',
    };

    const filledColumn = find((c) => c.name === teamColumn.name && c.type === teamColumn.type, teamInRegistry.columns);
    if (filledColumn) {
      column.value = filledColumn.value;
      column.url = filledColumn.url;
    }

    columns.push(column);
  });

  const staffs = [];
  registry.staff_titles.forEach((teamStaff) => {
    // 已經有同名人員就不放
    if (find((s) => s.title === teamStaff.title, staffs)) {
      return;
    }

    const staff = {
      ...teamStaff,
    };

    let filledColumns = [];
    const filledStaff = find((s) => s.title === teamStaff.title, teamInRegistry.staffs);
    if (filledStaff) {
      filledColumns = filledStaff.columns;
    }

    const staffColumns = [];
    teamStaff.columns.forEach((staffColumn) => {
      if (staffColumn.type !== 'PDF') {
        return;
      }

      // 已經有同名欄位就不放
      if (find((c) => c.name === staffColumn.name, staffColumns)) {
        return;
      }

      const column = {
        ...staffColumn,
        value: '',
        url: '',
      };

      const filledColumn = find((c) => c.name === staffColumn.name && c.type === staffColumn.type, filledColumns);
      if (filledColumn) {
        column.value = filledColumn.value;
        column.url = filledColumn.url;
      }

      staffColumns.push(column);
    });
    staffs.push({
      ...staff,
      pdfColumns: staffColumns,
    });
  });

  const players = [];
  teamInRegistry.players.forEach((player) => {
    const columns = [];
    registry.player_columns.forEach((playerColumn) => {
      if (playerColumn.type !== 'PDF') {
        return;
      }

      // 已經有同名欄位就不放
      if (find((c) => c.name === playerColumn.name, columns)) {
        return;
      }

      const column = {
        ...playerColumn,
        value: '',
        url: '',
      };

      const filledColumn = find((c) => c.name === playerColumn.name && c.type === playerColumn.type, player.columns);
      if (filledColumn) {
        column.value = filledColumn.value;
        column.url = filledColumn.url;
      }

      columns.push(column);
    });

    players.push({
      ...player,
      pdfColumns: columns,
    });
  });

  return {
    pdfColumns: columns,
    staffs,
    players,
  };
};
